import React from 'react';
import { Empty, Card, Button } from 'antd';
import { FieldTimeOutlined } from '@ant-design/icons';

export interface PageLoadingErrorProps {
  /**
   * Retries whatever failed. Without it the page is a dead end: the only other ways out
   * are an unrelated cache invalidation or a reload, neither of which the user can see.
   */
  onRetry?: () => void;
}

export const PageLoadingError = ({ onRetry }: PageLoadingErrorProps) => {
  return (
    // TODO Create a custom image to differentiate between not found
    <Card>
      <Empty
        description={
          <>
            <FieldTimeOutlined /> Your request timed out. Please try again.
          </>
        }
      >
        {onRetry && (
          <Button type="primary" onClick={onRetry}>
            Try again
          </Button>
        )}
      </Empty>
    </Card>
  );
};

export default PageLoadingError;
